import { render, staticRenderFns } from "./TechnicalDecisionPanel.vue?vue&type=template&id=1572a78a&scoped=true&"
import script from "./TechnicalDecisionPanel.vue?vue&type=script&lang=js&"
export * from "./TechnicalDecisionPanel.vue?vue&type=script&lang=js&"
import style0 from "./TechnicalDecisionPanel.vue?vue&type=style&index=0&id=1572a78a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1572a78a",
  null
  
)

export default component.exports